import { when } from 'mobx';
import { CookieNoticeStore } from '../../components/cookie-notice/store';
import { injectTSDI } from '../tsdi';
import { TrackingIdDto } from '../api/dtos';
import { GoogleAnalytics, UtmParams } from './google-analytics';
import { FacebookPixel } from './facebook-pixel';

export const initializeAnalytics = async (
    trackingId: TrackingIdDto | undefined
) => {
    if (
        !trackingId?.facebookPixelId &&
        !trackingId?.googleAnalyticsAccountNumber
    ) {
        return;
    }
    const cookieNoticeStore = injectTSDI(CookieNoticeStore);
    const facebookPixelStore = injectTSDI(FacebookPixel);
    const googleAnalyticsStore = injectTSDI(GoogleAnalytics);

    const { googleAnalyticsAccountNumber, facebookPixelId } = trackingId;

    await when(() => cookieNoticeStore.marketingEventsEnabled);

    const globalAnalyticsAccountId = googleAnalyticsAccountNumber;

    if (globalAnalyticsAccountId) {
        void googleAnalyticsStore.enableAccount(globalAnalyticsAccountId);
    }

    const globalPixelId = facebookPixelId;

    if (globalPixelId) {
        facebookPixelStore.enablePixel(globalPixelId);
    }
};

export const googleAnalyticsTrack: GoogleAnalytics['trackEvent'] = (
    ...args
) => {
    const store = injectTSDI(GoogleAnalytics);
    return store.trackEvent(...args);
};

export const facebookPixelTrack: FacebookPixel['trackEvent'] = (...args) => {
    const store = injectTSDI(FacebookPixel);
    return store.trackEvent(...args);
};

export const utmParamsTracking = (
    navigationEntries: PerformanceEntryList,
    locationSearch: string
) => {
    navigationEntries.forEach((entry) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (
            localStorage.getItem('utm-params') !== locationSearch &&
            entry?.toJSON()?.type !== 'reload'
        ) {
            localStorage.setItem('utm-params', locationSearch);
            const urlUtmParams = new URLSearchParams(locationSearch);
            const utmObject: { [key: string]: string } = {};

            urlUtmParams.forEach((value, key) => {
                if (UtmParams.includes(key)) {
                    utmObject[key] = value;
                }
            });
            googleAnalyticsTrack({
                ...utmObject,
                value: 100
            });
        }
    });
};
